import React from "react";
import SuccessMessage from "../../../components/SuccessMessage/SuccessMessage";

export default function PasswordResetRequestSuccess() {
  return (
    <SuccessMessage
      title="Du hast dein Passwort vergessen?"
      buttonText="Zurück zum Login"
    >
      <p>
        <strong>Aktion erfolgreich</strong>
      </p>
      <p>
        Wir senden dir einen Link per E-Mail, über den du ein neues Passwort
        vergeben kannst.
        <br />
        <strong>Bitte beachte: </strong>Dieser Link ist zu deiner Sicherheit nur
        24 Stunden gültig. Aus technischen Gründen kann der Versand bis zu 60
        Minuten dauern.
      </p>
    </SuccessMessage>
  );
}
